import { Grid, Typography } from "@mui/material"
import { FieldValues, UseFormReturn } from "react-hook-form"
import { ActionCard } from "../../../../../components/widgets/ActionCard";
import { AddBox, FilePresent } from "@mui/icons-material";
import { col4 } from "../../../../../common/utils";
import { useTranslation } from "react-i18next";



interface Props<T extends FieldValues> {
    form: UseFormReturn<T>;
    handleNext: VoidFunction;
}

export const InsertMode = ({ form, handleNext }: Props<any>) => {

    const { t } = useTranslation("dataIO");

    const handleSelectMode = (mode: 'manual' | 'template') => {
        form.setValue('insertMode', mode);
        handleNext();
    }

    return (
        <>
            <Grid size={12}>
                <Typography variant="h5" fontWeight={400} textAlign='center'>
                    {t("import/select import mode")}
                </Typography>
            </Grid>
            <Grid size={12} container justifyContent="center" spacing={2}>
                <Grid size={col4}>
                    <ActionCard
                        icon={<AddBox color="action" sx={{fontSize: '48px'}} />}
                        title={t("import/manual")}
                        description={t("import/manual_description")}
                        onClick={() => handleSelectMode('manual')}
                    />
                </Grid>
                <Grid size={col4}>
                    <ActionCard
                        icon={<FilePresent color="action" sx={{fontSize: '48px'}} />}
                        title={t("import/template")}
                        description={t("import/template_description")}
                        onClick={() => handleSelectMode('template')}
                    />
                </Grid>
            </Grid>
        </>
        
    )
}